/*global _ */
import RocketEffect from './webpack/rocket-effect-loader'
import {render} from './vuestrap/render'

const {addiesaas, vuestrap, EventBus, Vue} = RocketEffect

const debugLog = (...args) => {
  const {jsDebugLog, env} = addiesaas.config || {}
  const notProd = env !== 'production'
  const canLog = jsDebugLog || (jsDebugLog !== false && notProd)
  EventBus.$emit('addiesaas.debug.log', ...args)
  if (canLog) {
    console.log(...args)
  }
}

addiesaas.init = async (el, options, config) => {

  EventBus.$emit('addiesaas.app.beforeInit', el, addiesaas, RocketEffect)

  if (!vuestrap.store.getters.authFetched && (vuestrap.store.getters.authCheck || vuestrap.store.getters.authToken)) {
    try {
      await vuestrap.store.dispatch('fetchUser')
    } catch (e) {
      //
    }
  }

  const customVueStrap = {...vuestrap, el, ...options || {}}
  const VueApp = new Vue(customVueStrap)

  RocketEffect.apps = [...RocketEffect.apps || [], VueApp]

  EventBus.$emit('addiesaas.app.init', VueApp, addiesaas, RocketEffect)
  config = config || {}
  const componentName = config.componentName
  if (componentName) {
    EventBus.$emit(`addiesaas.app.init.${componentName}`, VueApp, addiesaas, RocketEffect, config)
  }
  return VueApp
}

addiesaas.initSync = (options, config) => {
  EventBus.$emit('addiesaas.app.beforeInit', options, addiesaas, RocketEffect)

  const customVueStrap = {...vuestrap, ...options || {}}
  const VueApp = new Vue(customVueStrap)

  RocketEffect.apps = [...RocketEffect.apps || [], VueApp]
  EventBus.$emit('addiesaas.app.init', VueApp, addiesaas, RocketEffect)
  config = config || {}
  const componentName = config.componentName
  if (componentName) {
    EventBus.$emit(`addiesaas.app.init.${componentName}`, VueApp, addiesaas, RocketEffect, config)
  }
  return VueApp
}

addiesaas.render = render

EventBus.$emit('addiesaas.beforeInit', addiesaas, RocketEffect)

const execCallback = (callbacks, noDefer) => {
  callbacks = _.castArray(callbacks)
  while (callbacks.length) {
    const callback = callbacks.shift()
    if (_.isFunction(callback)) {
      if (noDefer) {
        callback.call(RocketEffect)
      } else {
        setTimeout(((c) => () => {
          c.call(RocketEffect)
        })(callback), 0)
      }
    }
  }
}

// cache pre-init ready callbacks
let preInitReadyCallbackQueue = addiesaas.ready && addiesaas.ready.callbacks || []
addiesaas.ready = (callbacks, immediate) => {
  if (callbacks && immediate) {
    debugLog('Run ready callback [immediate]', {callbacks, RocketEffect})
    execCallback(callbacks, true)
  }
  let beforeReadyQueue = _.castArray(addiesaas.beforeReady || [])
  if (beforeReadyQueue.length) {
    debugLog('Flush beforeReady callback', {beforeReadyQueue:[...beforeReadyQueue], RocketEffect})
    execCallback(beforeReadyQueue, true)
  }
  if (preInitReadyCallbackQueue.length) {
    debugLog('Flush initial Ready callback queue', {preInitReadyCallbackQueue, RocketEffect})
    execCallback(preInitReadyCallbackQueue)
  }
  const queue = addiesaas.ready.callbacks || []
  if (queue.length) {
    debugLog('Flush Ready callback queue again', {queue, RocketEffect})
    execCallback(queue)
  }

  if (callbacks && !immediate) {
    debugLog('Run ready callback', {callbacks, RocketEffect})
    execCallback(callbacks)
  }
}

const beforeReadyQueue = addiesaas.beforeReady || (addiesaas.beforeReady = [])
EventBus.$emit('addiesaas.beforeReady', beforeReadyQueue, RocketEffect)

setTimeout(() => {
  addiesaas.ready(beforeReadyQueue, true)
}, 0)

setTimeout(() => {
  EventBus.$emit('addiesaas.ready', RocketEffect)
}, 0)

export default RocketEffect
